<div class="flx-modal" role="dialog" aria-modal="true">
    <!-- Header -->
    <div class="flx-modal__header w-f3">
        <div class="with-desc">
            <h2 *ngIf="data.mode == 'create'">{{translate?.general.buttons.configure.singular}} {{translate?.general.buttons.new.singular}}
                Certification</h2>
            <h2 *ngIf="data.mode == 'edit'">{{translate?.general.buttons.edit.singular}}
                Certificate Type</h2>
        </div>

        <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" (click)="onCancelClick()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <!-- Body -->
    <div class="flx-modal__body skim gap-3">
        <form [formGroup]="certificateTypesForm">
            <div>
                <div class="status-field">
                    <label class="field-title">{{translate?.setup.modules.types.sections.sec0.plural}}</label>
                </div>

                <!-- Name -->
                <div class="status-field">
                    <label class="field-label mandatory">Name</label>
                    <div class="field-row field-row--auto">
                        <input type="text" formControlName="name" [placeholder]="'e.g., Water Quality Test'" pInputText
                            [ngClass]="{
                                'invalid-input':
                                    certificateTypesForm.get('name').invalid &&
                                    (certificateTypesForm.get('name').dirty || certificateTypesForm.get('name').touched)
                            }">
                    </div>
                    <div class="p-error text-10"
                        *ngIf="
                            (certificateTypesForm.controls['name'].touched || certificateTypesForm.controls['name'].dirty) &&
                            certificateTypesForm.controls['name'].invalid
                        ">
                        <div *ngIf="certificateTypesForm.controls['name'].errors?.required">{{translate?.general.validationFE.requiredField}}</div>
                        <div *ngIf="certificateTypesForm.controls['name'].errors?.pattern">Only letters and numbers are allowed</div>
                        <div *ngIf="certificateTypesForm.controls['name'].errors?.maxlength">Maximum length of 255 characters exceeded</div>

                    </div>
                </div>
                <!-- Freq -->
                <div class="status-field">
                    <label class="field-label mandatory">Frequency</label>
                    <div class="field-row field-row--auto">
                        <p-dropdown [options]="frequencyList" optionLabel="fName" 
                            optionValue="fVal" formControlName="frequency" 
                            [placeholder]="'Select a frequency for this certificate'">
                        </p-dropdown>
                    </div>
                    <div class="p-error text-10"
                        *ngIf="
                            (certificateTypesForm.controls['frequency'].touched || certificateTypesForm.controls['frequency'].dirty) &&
                            certificateTypesForm.controls['frequency'].invalid
                        ">
                        <span *ngIf="certificateTypesForm.controls['frequency'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                    </div>
                </div>
                <!-- Authority -->
                <div class="status-field">
                    <label class="field-label">Authority</label>
                    <div class="field-row field-row--auto">
                        <input type="text" formControlName="authority" pInputText 
                        [ngClass]="{'invalid-input': certificateTypesForm.get('authority')?.invalid &&
                            (certificateTypesForm.get('authority')?.dirty || certificateTypesForm.get('authority')?.touched)
                        }" 
                        [placeholder]="'Enter an authority for this certification'">
                    </div>
                    <div class="p-error text-10"
                        *ngIf="
                            (certificateTypesForm.controls['authority'].touched || certificateTypesForm.controls['authority'].dirty) &&
                            certificateTypesForm.controls['authority'].invalid
                        ">
                        <span *ngIf="certificateTypesForm.controls['authority'].errors?.maxlength">{{'Maximum length of 255 characters exceeded'}}</span>
                    </div>
                </div>
                <div class="status-field">
                    <label class="field-label mandatory">Start Date</label>
                    <div class="field-row field-row--auto">
                         <p-calendar [defaultDate]="defaultDate" [minDate]="minDate" name="startDate" [showIcon]="true"
                            selectionMode="single" formControlName="startDate" styleClass="cal-btn"
                            dateFormat="dd/mm/yy" yearRange="2000:2030" type="text" placeholder="dd/mm/yy"
                            [yearNavigator]="true" appendTo="body"></p-calendar>
                    </div>
                    <div class="p-error text-10"
                        *ngIf="
                            (certificateTypesForm.controls['startDate'].touched || certificateTypesForm.controls['startDate'].dirty) &&
                            certificateTypesForm.controls['startDate'].invalid
                        ">
                        <span *ngIf="certificateTypesForm.controls['startDate'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                    </div>
                </div>
                <div class="status-field">
                    <div class="flex-align-baseline gap-2">
                        <label class="field-label mandatory">Due Date Derivation</label>
                        <span><i class="pi pi-info-circle" pTooltip="Option for when the next certification should be generated"></i></span>
                    </div>
                    <div class="field-row field-row--auto">
                        <p-dropdown formControlName="dueDateDerivation" [options]="dueDateOptions" 
                            optionLabel="name" optionValue="value" [placeholder]="'Select a due date derivation'" >
                        </p-dropdown>
                    </div>
                    <div class="p-error text-10" *ngIf="(certificateTypesForm.controls['dueDateDerivation'].touched || certificateTypesForm.controls['dueDateDerivation'].dirty) &&
                            certificateTypesForm.controls['dueDateDerivation'].invalid">
                        <span *ngIf="certificateTypesForm.controls['dueDateDerivation'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                    </div>
                </div>
            </div>


            <div class="mt-22px">
                <div class="flex-between">
                    <label class="field-title">Reminders</label>

                    <label class="field-chip">{{reminders.length}} of 3</label>

                </div>

                <!-- Reminder rows — inside .flx-modal__body -->
                <div class="reminder-list">
                    <div class="empty-page-data border-0" *ngIf="reminders.length === 0">
                        <div class="content">
                            <img src="../../../../assets/svg/empty-state-rev.svg" alt="No Records Found" id="img_NoRecordsFound" /> 
                        </div>
                    </div>

                    <div class="reminder-row" *ngFor="let reminder of reminders; let i = index; trackBy: trackByReminder" [ngClass]="certificateTypesForm.get('notiType'+i)?.value == 'Both' ? 'reminder-row-block' : ''">
                        <span class="reminder-row__index">{{ i + 1 }}</span>
                        <p-dropdown [options]="timingOptions" formControlName="notiFreq{{i}}" optionLabel="label" optionValue="value" placeholder="30 days before due"></p-dropdown>
                        <p-dropdown [options]="channelOptions" formControlName="notiType{{i}}" optionLabel="label" optionValue="value" placeholder="Select Notification Type" (onChange)="onChannelChange($event, i)"></p-dropdown>
                        
                        <p-dropdown [options]="reminder.notificationList" formControlName="noti{{i}}" optionLabel="name" optionValue="id" [placeholder]="notificationPlaceholderText" ></p-dropdown>
                        
                        <p-dropdown *ngIf="certificateTypesForm.get('notiType'+i)?.value == 'Both'" [options]="reminder.notificationListInApp" formControlName="notiInApp{{i}}" optionLabel="name" optionValue="id" placeholder="Select Notification for In-app" ></p-dropdown>

                        <button class="reminder-row__remove" type="button" [pTooltip]="translate?.general.buttons.remove.singular" (click)="removeReminder(i, reminder)">
                            <i class="fa-regular fa-xmark"></i>
                        </button>
                    </div>

                </div>                                                                                                             

                <!-- Send a completion notification -->
                <div class="flex-between">
                    <div class="field-row field-row--checkbox mb-0">
                        <div class="p-field-checkbox">
                            <p-checkbox formControlName="sendNoti" [binary]="true" (onChange)="onSendNotiChanged($event)"></p-checkbox>
                        </div>
                        <span class="text-12">Send a completion notification</span>
                    </div>

                    <p-button label="Add Reminder" (onClick)=" addReminder()" [disabled]="reminders.length >= 3"></p-button>
                </div>
                <div class="status-field mt-2" *ngIf="certificateTypesForm.controls['sendNoti'].value == true">
                    <!-- User Group -->
                    <label class="field-label">Notify</label>
                    <div class="field-row field-row--auto">
                        <p-dropdown formControlName="notify" [options]="userGroups" optionLabel="name" optionValue="id" [placeholder]="'Select a user group to be notified of this certification'" ></p-dropdown>
                    </div>
                     <div class="p-error text-10"
                        *ngIf="
                            (certificateTypesForm.controls['notify'].touched || certificateTypesForm.controls['notify'].dirty) &&
                            certificateTypesForm.controls['notify'].invalid
                        ">
                        <span *ngIf="certificateTypesForm.controls['notify'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- Footer -->
    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="onCancelClick()">
            {{ translate?.general.buttons.cancel.singular }}
        </button>
        <p-button styleClass="h-32" type="button" 
            [disabled]="certificateTypesForm.invalid" 
            [label]="translate?.general.buttons.save.singular" 
            (onClick)="addCertificateType()">
        </p-button>
    </div>
</div>